import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { store } from "./store.js";
import router from "./router";
import VueCookies from "vue-cookies";
import "chartist/dist/chartist.min.css";
import DashboardPlugin from "./plugins/dashboard-plugin";
import VueSocialSharing from "vue-social-sharing";
import VuePlyr from "vue-plyr";
// import VueHtmlToPaper from 'vue-html-to-paper';
import "vue-plyr/dist/vue-plyr.css";

import VPageGuide from "vue-page-guide";
import CalendarPlugin from "./plugins/calendar-plugin";
import LogPlugin from "./plugins/log-plugin";

import UUID from "vue-uuid";

Vue.use(UUID);

Vue.config.productionTip = false;

Vue.use(VPageGuide);
Vue.use(CalendarPlugin);
Vue.use(LogPlugin);

const fb = require("./firebaseConfig.js");

Vue.use(VueSocialSharing);
Vue.use(require("vue-chartist"));
Vue.use(DashboardPlugin);

Vue.use(VueCookies);
Vue.use(require("vue-moment"));
Vue.use(VuePlyr, {
  plyr: {},
});
// Vue.use(VueHtmlToPaper, {
//   name: '_blank',
//   specs: [
//     'fullscreen=yes',
//     'titlebar=yes',
//     'scrollbars=yes'
//   ],
//   styles: [
//     'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
//     'https://unpkg.com/kidlat-css/css/kidlat.css'
//   ]
// });
// import YQuestionnaires from '@/components/YQuestionnaires'
// import YQuesionDetail from '@/components/YQuesionDetail'
import VueRouter from "vue-router";
Vue.use(VueRouter);
Vue.config.productionTip = false;

Vue.$cookies.config("7d");
Vue.config.productionTip = false;

import myfunction from "@/components/global/myfunction.js";
import { v4 as uuidv4 } from "uuid";

if (!store.state.uniqueDeviceId) store.set("uniqueDeviceId", uuidv4());
console.log(store.state.uniqueDeviceId);

// onAuthStateChanged fires again on every sign-in, and mounting a second app
// on the same router re-runs navigation under the visible one — a failed page
// chunk then leaves the screen blank. Mount once.
let appMounted = false;

// A school with no active doctor account works as a no-doctor school (screening).
async function hasNoDoctor(schoolRef) {
  try {
    const snap = await schoolRef.collection("teachers").where("role", "==", "schooldoctor").get();
    return !snap.docs.some((d) => {
      const x = d.data();
      return x.deleted !== true && x.moved !== true && !x.virtualRole;
    });
  } catch (error) {
    return false;
  }
}

fb.auth.onAuthStateChanged(async (user) => {
  try {
    var doc;
    var userObj;
    var ddoc;
    // console.log(user);
    if (user) {
      store.set("currentUser", user);
    }
    // Teacher/student logins keep their doc path in mendleUserRef and now also
    // hold a Firebase Auth session (synthetic/medle email), so the email lookup
    // below would never match them — restore from the doc path instead. The
    // lookup only fits gmail workers, who don't set mendleUserRef.
    if (user && !store.state.mendleUserRef) {
      doc = await fb.db
        .collectionGroup("teachers")
        .where("email", "==", user.email)
        .where("deleted", "==", false)
        .get();
      if (!doc || doc.empty) {
        doc = await fb.db
          .collectionGroup("students-" + store.state.kSchoolStartYear)
          .where("email", "==", user.email)
          .where("deleted", "==", false)
          .where("moved", "==", false)
          .limit(1)
          .get();
      }

      if (!doc.empty) {
        userObj = doc.docs.filter(
          (d) => d.data().role != "teacher" && d.data().isDemo !== true,
        )[0];
        if (userObj && userObj.exists) {
          let userData = userObj.data();
          userData.id = userObj.id;
          userData.ref = userObj.ref;
          // console.log(userData)
          if (userData.school) {
            userData.ppschool = userData.school.ref.path;
            await userData.school.ref.get().then((doc) => {
              userData.school = doc.data();
              userData.school.id = doc.id;
              userData.school.ref = doc.ref;
            });

            userData.school.noDoctorAccount = await hasNoDoctor(userData.school.ref);
            await new Promise((resolve) => {
              fb.db
                .collection("_schoolDatas")
                .doc(userData.school.id)
                .onSnapshot((doc) => {
                  if (doc.exists) {
                    userData.school.schoolDatas = doc.data();
                    if (userData.school.noDoctorAccount) userData.school.schoolDatas.noSchoolDoctor = true;
                  }
                  resolve();
                });
            });
          } else {
            if (userData.ref.parent.parent) {
              userData.ppschool = userData.ref.parent.parent.path;
              // userData.ppschool = "schools/YodtLTjL7GNxY9NBjWco"
              //userData.ppschool ="schools/QkJ6bvs865mbXINzHhKB"
              //DEBUG
              //userData.ppschool = "schools/nJ0ML9ltkfYarYKzKgI7" //zavkhan numrog
              // userData.ppschool = "schools/wXaBdoO4uNHp5HYUJbpK"
              // userData.ppschool = "schools/wXaBdoO4uNHp5HYUJbpK"
              await fb.db
                .doc(userData.ppschool)
                .get()
                .then((doc) => {
                  userData.school = doc.data();
                  userData.school.id = doc.id;
                  userData.school.ref = doc.ref;
                });
              userData.school.noDoctorAccount = await hasNoDoctor(userData.school.ref);
              await new Promise((resolve) => {
                fb.db
                  .collection("_schoolDatas")
                  .doc(userData.school.id)
                  .onSnapshot((doc) => {
                    if (doc.exists) {
                      userData.school.schoolDatas = doc.data();
                      if (userData.school.noDoctorAccount) userData.school.schoolDatas.noSchoolDoctor = true;
                    }
                    resolve();
                  });
              });
            } else {
              if (userData.role == "aspecialist") {
                userData.school = null;
                userData.ppschool = null;
              } else {
                if (store.state.selectedSchoolRef) {
                  userData.ppschool = store.state.selectedSchoolRef;

                  // fb.db.doc(store.state.selectedSchoolRef).get().then((doc) => {
                  //   let school = doc.data()
                  //   school.id = doc.id
                  //   school.ref = doc.ref
                  //   userData.school = school
                  // })

                  ddoc = await fb.db.doc(store.state.selectedSchoolRef).get();
                  let school = ddoc.data();
                  if (school) {
                    school.id = ddoc.id;
                    school.ref = ddoc.ref;
                    userData.school = school;

                    userData.school.noDoctorAccount = await hasNoDoctor(userData.school.ref);
                    await new Promise((resolve) => {
                      fb.db
                        .collection("_schoolDatas")
                        .doc(userData.school.id)
                        .onSnapshot((doc) => {
                          if (doc.exists) {
                            userData.school.schoolDatas = doc.data();
                            if (userData.school.noDoctorAccount) userData.school.schoolDatas.noSchoolDoctor = true;
                          }
                          resolve();
                        });
                    });
                  }
                } else {
                  userData.ppschool = null;
                }
              }
              if (userData.cityCode) {
                fb.db
                  .collection("schools")
                  .where("deleted", "==", false)
                  .orderBy("name", "asc")
                  .onSnapshot((schools) => {
                    store.state.availableSchools = [];
                    var counter = 0;
                    schools.forEach((doc) => {
                      let school = doc.data();
                      school.id = doc.id;
                      school.ref = doc.ref;
                      // school.name2 = counter
                      if (
                        school.cityCode &&
                        userData.cityCode &&
                        school.cityCode == userData.cityCode
                      ) {
                        counter++;
                        school.name2 =
                          counter +
                          ". " +
                          school.name +
                          (school.city ? " /" + school.city + "/" : "");
                        school.index = counter;
                        store.state.availableSchools.push(school);
                      }
                    });
                  });
              } else {
                fb.db
                  .collection("schools")
                  .where("deleted", "==", false)
                  .orderBy("name", "asc")
                  .onSnapshot((schools) => {
                    store.state.availableSchools = [];
                    var counter = 0;
                    schools.forEach((doc) => {
                      let school = doc.data();
                      school.id = doc.id;
                      school.ref = doc.ref;
                      counter++;
                      school.name2 =
                        counter +
                        ". " +
                        school.name +
                        (school.city ? " /" + school.city + "/" : "");
                      school.index = counter;
                      store.state.availableSchools.push(school);
                    });
                  });
              }
            }
          }
          // console.log('department-' + userData.school.currentYear)
          // console.log(['departmentName-' + userData.school.currentYear])
          // console.log(userData)
          // if (userData.school && userData.role == 'student' && !userData.departmentIndex) {
          //   await userData['departmentName-' + userData.school.currentYear].get().then((doc) => {
          //     userData.departmentIndex = doc.data().index
          //     userData.ref.update({
          //       departmentIndex: userData.departmentIndex
          //     })
          //   })
          // }

          if (userData.school) {
            // userData.school.currentYear = store.state.kSchoolStartYear;
          }
          store.set("userData", userData);
        }
      }
    } else {
      if (store.state.mendleUserRef) {
        userObj = await fb.db.doc(store.state.mendleUserRef).get();
        if (userObj.exists) {
          let userData = userObj.data();
          userData.id = userObj.id;
          userData.ref = userObj.ref;

          // fb.dbDSStorage.collection("testtest").get().then((docs)=>{
          //   console.log(docs)
          // }) TODO

          if (userData.school) {
            userData.ppschool = userData.school.ref.path;
            await userData.school.ref.get().then((doc) => {
              userData.school = doc.data();
              userData.school.id = doc.id;
              userData.school.ref = doc.ref;
            });
            userData.school.noDoctorAccount = await hasNoDoctor(userData.school.ref);
            await new Promise((resolve) => {
              fb.db
                .collection("_schoolDatas")
                .doc(userData.school.id)
                .onSnapshot((doc) => {
                  if (doc.exists) {
                    userData.school.schoolDatas = doc.data();
                    if (userData.school.noDoctorAccount) userData.school.schoolDatas.noSchoolDoctor = true;
                  }
                  resolve();
                });
            });
          } else {
            if (userData.ref.parent.parent) {
              userData.ppschool = userData.ref.parent.parent.path;
              // userData.ppschool = "schools/YodtLTjL7GNxY9NBjWco"
              //userData.ppschool ="schools/QkJ6bvs865mbXINzHhKB"
              //DEBUG
              //userData.ppschool = "schools/nJ0ML9ltkfYarYKzKgI7" //zavkhan numrog
              // userData.ppschool = "schools/wXaBdoO4uNHp5HYUJbpK"
              // userData.ppschool = "schools/wXaBdoO4uNHp5HYUJbpK"

              await fb.db
                .doc(userData.ppschool)
                .get()
                .then((doc) => {
                  userData.school = doc.data();
                  userData.school.id = doc.id;
                  userData.school.ref = doc.ref;
                });
              userData.school.noDoctorAccount = await hasNoDoctor(userData.school.ref);
              await new Promise((resolve) => {
                fb.db
                  .collection("_schoolDatas")
                  .doc(userData.school.id)
                  .onSnapshot((doc) => {
                    if (doc.exists) {
                      userData.school.schoolDatas = doc.data();
                      if (userData.school.noDoctorAccount) userData.school.schoolDatas.noSchoolDoctor = true;
                    }
                    resolve();
                  });
              });
            } else {
              if (userData.role == "aspecialist") {
                userData.school = null;
                userData.ppschool = null;
              } else {
                if (store.state.selectedSchoolRef) {
                  userData.ppschool = store.state.selectedSchoolRef;

                  // fb.db.doc(store.state.selectedSchoolRef).get().then((doc) => {
                  //   let school = doc.data()
                  //   school.id = doc.id
                  //   school.ref = doc.ref
                  //   userData.school = school
                  // })

                  ddoc = await fb.db.doc(store.state.selectedSchoolRef).get();
                  let school = ddoc.data();
                  if (school) {
                    school.id = ddoc.id;
                    school.ref = ddoc.ref;
                    userData.school = school;
                  }
                } else {
                  userData.ppschool = null;
                }
              }
              fb.db
                .collection("schools")
                .orderBy("name", "asc")
                .onSnapshot((schools) => {
                  store.state.availableSchools = [];
                  var counter = 0;
                  schools.forEach((doc) => {
                    counter++;
                    let school = doc.data();
                    school.id = doc.id;
                    school.ref = doc.ref;
                    // school.name2 = counter + ". " + school.name
                    school.name2 =
                      counter +
                      ". " +
                      (school.name + school.city
                        ? " /" + school.city + "/"
                        : "");
                    school.index = counter;
                    if (
                      school.cityCode &&
                      this.userData.cityCode &&
                      school.cityCode == this.userData.cityCode
                    )
                      store.state.availableSchools.push(school);
                    //else store.state.availableSchools.push(school)
                  });
                });
            }
          }
          if (
            userData.school &&
            userData.role == "student" &&
            !userData.departmentIndex
          ) {
            // Students saved without a "department-<year>" reference (or for
            // another year) used to crash the whole login here. Use the
            // reference when it exists, else the student's ACADEMIC_LEVEL.
            const departmentRef =
              userData["department-" + userData.school.currentYear];
            let departmentIndex = null;
            if (departmentRef && departmentRef.get) {
              const doc = await departmentRef.get();
              if (doc.exists && doc.data().index != null)
                departmentIndex = doc.data().index;
            }
            if (departmentIndex == null && userData.ACADEMIC_LEVEL)
              departmentIndex = Number(userData.ACADEMIC_LEVEL);
            if (departmentIndex != null) {
              userData.departmentIndex = departmentIndex;
              userData.ref.update({ departmentIndex });
            }
          }

          if (userData.school) {
            // userData.school.currentYear = store.state.kSchoolStartYear;
          }

          store.set("userData", userData);
        }

        //store.dispatch('clearData')
      }
      // if (user) {
      //   store.commit('setCurrentUser', user)
      //   store.dispatch('fetchUserProfile')

      // } else {
      //   store.dispatch('clearData')
      // }
    }
  } catch (e) {
    // A failed lookup must not stop the app from appearing: without this the
    // page stays blank, with no login screen and no message.
    console.error("main.js auth bootstrap failed", e);
  }

  if (store.state.userData) {
    // console.log(store.state.userData);
    // Initialize and load calendar using the new plugin
    Vue.$calendar.init(store.state.userData);
    Vue.$calendar.loadCalendar().catch(console.error);
  }

  if (appMounted) return;
  appMounted = true;

  new Vue({
    vuetify,
    router,
    store,
    render: (h) => h(App),
    mixins: [myfunction],
    created() {
      //  fb.db.collection("_news_bagshsystem").doc("zar").get
    },
  }).$mount("#app");
});
